import { createFileRoute } from '@tanstack/react-router';
import { AuthTemplate } from '@/components/auth/auth-template';
import { SetPasswordForm } from '@/features/auth/set-password-form';

export const Route = createFileRoute('/set-password')({
  validateSearch: (search: Record<string, unknown>): { token: string } => ({
    token: typeof search['token'] === 'string' ? search['token'] : '',
  }),
  component: () => {
    const { token } = Route.useSearch();
    return (
      <AuthTemplate>
        <SetPasswordForm token={token} />
      </AuthTemplate>
    );
  },
});
